module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "preface"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('strong', [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOT USED TO")]), _vm._v(" her laugh by being around it all the time. My friends would remind me how special it was—“Wow, that is one great laugh your mom has.” What it carried was joy to the max. It both created, and was carried by, a big happy bandwidth. Rita was a small person, but she had a set of overcapacity, drill-sergeant lungs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she was on her deathbed at age 92, I heard what was left of her laugh in her diminished state. She had kept the laugh, and its roots—the stance toward life of finding the fun everywhere—until the end of her days. I had my last hour with Mom on her last full day of partial consciousness. She’d fade in and out some, but she knew me and my two sisters, and we spent the day holding her hand and conversing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In my last hour with her alone, I pulled out my guitar and played and sang. I had heard that music soothes the dying. After one song, she surprised me with a very clear “That was a good performance,” the last words she ever spoke to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It occurred to me, while holding her hand, to go over the memories that she had cherished all her life and told and retold, often from different angles, one last time. These memories had become one of her life sources of joy and meaning. I said things like, “Remember that huge windstorm up in "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("Wisconsin at Bud’s house? We cut through four trees the next day just to get our car out of the driveway.” I recalled a memory of her recalling memories. “Remember you and Dorothy and Helen (her sisters) sitting on the porch in Iowa under the stars, telling stories about the Cunninghams’ life on the farm? Remember the time Dorothy jumped onto the fat bull snake, "), _c('em', [_vm._v("barefoot")]), _vm._v("? . . . Remember . . .?” She kept smiling and nodding, eyes still sparkling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I did in that last hour what I had learned from her. I harvested her past in a final sweep of rich memories. We relished the stories of her life with her husband, Paul, and her siblings. Very soon after we had reviewed the constellation of images that made up her interior world and brought her laugh to life, she went out of consciousness.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rita would like it that she helped to inspire a book about making our yesterdays a resource that we can call upon now and in our uncertain, full-of-possibilities future. In addition to having been her son, I am a father and grandpa, an author, a teacher of executive coaching, and a mentor to leaders. I live in the Midwest and the East, was born in rural Iowa like Rita, and worked in leadership development with corporations, nonprofits, and government for over 30 years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book was born out of that work and study. I noticed early on how well most effective people had defined themselves using their personal history. And I also noticed the opposite—how less-effective people were usually fuzzy about their yesterdays. It became time to write when I clearly saw that what was so important was not obvious to most.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("I did not write this book to talk about the impact of the generations before you. That is an important topic but not in the scope of this book. Nor is it about past lives, if you are into that kind of thinking. It is about your personal history starting at day one, breath one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much is being taught on presence in the moment, on the benefits and processes for staying in the now, that is both widespread and very useful. You may have read some of the books on this movement or at least heard about it. I have benefited from this thinking in many ways. It is my contention, however, that presence is only half the story. In this book, I want to fill in the other half. We cannot afford to miss the half on our past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is about using your past creatively in order to better live your present and to robustly lean into your future. It describes how to fix the underuse and misuse of the building blocks of our lives, our yesterdays. It is a systematic and creative guide to making your past sing and play and work for you. And your yesterdays can indeed do all of those things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This trek into your past is the primary means to both mine your hidden gold and reprogram your hidden self-limiting beliefs. It is not about planning and goal-setting your way to your future, which you already know how to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Planning your way through the limits that stem from your yesterdays is like dynamiting your way through cobwebs—the wrong tool, and likely to do more damage than good")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our mind and will set goals and plans within whatever context we provide them. What we work on here is the context of our thinking and willing, and so we put energy into structures more foundational than planning. When we fully harvest our past, we provide a rich context for moving "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("forward. Our career and life plans can best emerge from the core places in our being. With clarity on our personal history, we can access the wellspring of our truest contributions and the source of our best decisions for our larger life journey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this work on your yesterdays, then, expect something different. The aim of this book is to rework your memories, and the helpful and less-than-helpful lessons stemming from them, so that you can imagine and practice new ways of being, doing, and loving. Are there other ways to advance your self-knowledge and self-awareness? Of course—many valuable ones. This treatment, however, concerns one very important way that is undervalued and poorly taught.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("This book is about re-possibilitizing. It is about gathering important insights, and the wisdom that comes before informed action")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOULD")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAD")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUCK")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URIOUS")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCCESSFUL")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELPING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFESSIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is written for working people, for leaders and professionals and sole proprietors and nonprofit managers, for teachers and those in health care, for artists—for all those who want to open up new possibilities for living, with an emphasis on their work life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wrote it for people who already have dynamic careers and for those who may be stuck and not moving. In a comic strip some years back, Dilbert responds to a simple “How is work?” question from his mom by saying, “Incompetence hangs in the air like the cold stench of death. I’m drowning, and monkeys dressed as lifeguards are throwing me anvils.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("If you have caught any anvils recently, this book is for you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And it is also very much meant for the anvil-free who experience work success, and who have put useful professional and personal growth practices in place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A premise of this book is that no matter where you are on the spectrum of life’s success-o-meter, even at the top, there is still work with your past, good work, that will add value to your current and future life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So if you are at the top with")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("a million or two in savings, a perfect partner, great health and good looks, fun kids, and a career filled with ever more promise")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("or in the middle with")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("a good middle-class life with a little savings, a healthy lifestyle, pretty good looks, a career that is more steady than spectacular, a stable partner, and a mortgage that won’t bury you")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("or nearer the bottom with")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("too much debt, aches and stiffness, marginal looks, an unreliable car, a dead-end job with two outplacements behind you, kids who ignore you, and a relationship in serious need of some romance and zest")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("no matter where you are on that spectrum, this book adds value and important perspective. The outside of your life, as measured by the success-o-meter, is a weak indicator at "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("best of what still lies in your stored-up bank account of yesterdays that you can harvest to enhance and improve your life today and tomorrow. This book does not ignore the outside of your life, but it starts and ends with the inside, with your thoughts and your beliefs and all the mental-emotional-spiritual dynamics that determine the outside, as measured by the success-o-meter. This is about your inner theater and about you as the playwright.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of you have already taken action to grow. You attend professional or personal workshops, or you access faith-based or other forms of spiritual resources, or you engage a coach. These activities are so useful and will be markedly accelerated if your lessons from your yesterdays pop with the power of their singular truths.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("When people encounter the deep currents of their unique path, that is where substantial growth resides.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is rare that even the highly successful, who are usually overbusy with success, have fully and creatively mined their unique history or know what their particular amalgamation of memories can mean and do for them.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PECIAL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD FOR THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELPERS")]), _vm._v("—C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OACHES AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNSELORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some people may be in a hindering profession, though I have yet to meet one. Many of us claim to be in the human development and helping professions. This book is meant for the general working professional and not exclusively "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("for development/helping professionals. Still, if you are a counselor, therapist, or leadership developer, you will find ideas that you can use for your clients.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is not written as a coaching book, but if you are a coach, you will still find ways to use it. As you know, we coaches focus more on the present and future than most therapists, but we assist our clients regularly by fighting off the faulty thinking and views that leak from their past into their present, inhibiting their achievement of worthwhile efforts. So don’t think of it as a coaching book, but use it as you will and tell me what happens.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALKED TO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ABOUT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AST")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In addition to years of observation and working with hundreds on the concepts presented in this book, I directly interviewed 14 individuals (and surveyed approximately 30 more). The list includes guitarist and performer Tommy Emmanuel; John Pepper, former CEO of Procter & Gamble; Gifford Pinchot, social entrepreneur and thought leader for innovation and sustainable business; Valerie Morris, CNN anchor for 15 years; and David Dotlich, author and leadership development guru. You will hear many of their stories. This is not meant to be a research book, but the positions I take and thoughts I emphasize come from more than my experience—they come from others’ as well.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW TO")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAD")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(": S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELF")]), _vm._v("-R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTION ON THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOLE OF")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Don’t be in any kind of hurry to read this book. This is more a slow-read book than a fast-read book, even though "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("it is chunked into small, digestible parts for easy access. Speed is not the enemy here, but it can hamper many kinds of growth. Set the book down after you hit a part that resonates; look out the window at 35,000 feet, across the crowded parking lot at your condo, or above the heads of the folks who slipped onto the subway with you; and think about what you just read.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To reap the most from this book will take self-reflection with heart. You will gain much as you muster up the will to take a look at your life, your work, and your past and its meanings. The examples and methods will support your quest for self-knowledge that matters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Splitting people into an artificial dichotomy of the person at work and the person in her personal life can cause problems. For the purpose of this book, then, we will touch on your personal life and harvest memories of events that occurred before the work stage of life. I will concentrate the majority of applications in the book, however, on work life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we use the term "), _c('em', [_vm._v("work")]), _vm._v(", keep in mind that we are not only talking about your job. This book’s focus is on any role that you care about, especially as you want to have a positive impact on the world of work and your community. Your role as a part-time artist or parent may currently hold the bigger promise of a contribution and grab the bigger share of your heart and imagination. I will often use the word "), _c('em', [_vm._v("lifework")]), _vm._v(" to designate your work and life and any role within a career or outside of it. We maintain a whole-person perspective throughout. By focusing on work, however, we enjoy the boundaries that come with a primary application.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOW OF THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The book has three parts. The first, comprising "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 1")]), _vm._v(" and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(", describes how and why we miss, through a kind of forgetting, the learning from our yesterdays. This cultural blind spot carries a big cost. A bit of theory describes the dynamics of how the assets and limits from our past get deposited in our memories, and how powerful that is for our current lives and work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second part, comprising "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 3")]), _vm._v(", "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(", and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(", is the how-to part of the book. It takes you through the steps for reclaiming the assets and recasting the lessons. This section describes the methods you can apply to your current settings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third part, comprising "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 6")]), _vm._v(" and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(", addresses two big issues: (1) How can I strike the balance of fitting in the world while making sure that I am uniquely my own person? (2) How can I acquire wisdom when I face life’s biggest challenges? This is answered in the last chapter.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MNESIA")]), _vm._v(", C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DEAS")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFIRMATIONS, AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XERCISES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each chapter has core features. The amnesia vignettes at the start briefly explore how movies and books have portrayed the damaging impact of disruption with our past. The core ideas at the end are the distilled lesson of the chapter. The statements of intent at the end are affirmations aimed at creating an inner resonance to move you ahead. Use these statements. Read them aloud. Print them out and tape them to your computer screen, your bathroom mirror. They act as a fuel additive, poured into the tank of your "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("positive restlessness and yearning. They will help you burn cleaner while you go about learning, growing, serving, and having fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the chapters that do not have exercises at their core, I provide questions and/or exercises so that you can apply the concepts and reflect as we go. Address the ones to which you are drawn, and of course make up your own.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INAL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERY")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After my mom and I shared some words on that cold February day, I left the sparse room knowing that we had enjoyed our last living connection. Many thoughts, questions, and feelings swirled around in my head and heart. I still carry one question with me: How can we live more like my mom, all the way to the end, with a joy for living that others feel, always?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We cannot address all of the mysteries that such a question conjures up, but we can address some. I am eager, after years of data gathering and thinking, to go down that path with you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("May we all harvest our powerful past in creative and life-enhancing ways.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("John P. Schuster")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Columbus, Ohio")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("November 2010")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('em', [_vm._v("Do not be afraid of the past. If people tell you that it is"), _c('br'), _vm._v("irrevocable, do not believe them. The past, the present and"), _c('br'), _vm._v("the future are but one moment in the sight of God. . . ."), _c('br'), _vm._v("Time and space . . . are merely accidental conditions of"), _c('br'), _vm._v("a thought. The imagination can transcend them. . . ."), _c('br'), _vm._v("Things, also, are in their essence what we choose to"), _c('br'), _vm._v("make them")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SCAR")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILDE")]), _vm._v(", "), _c('em', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFUNDIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769c4412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 81
// module chunks = 0